import moment from "moment";

export const getFeedbackSearchResultsRespAviation = (params, body) => {
  const commentTexts = {
    EFFICIENT_FLIGHT: [
      "taxi time was longer than expected",
      "ATC requested us to drop 4000ft below planned",
      "several re-routes from ATC which added extra flying time",
      "unable to climb to optimal altitude due to traffic",
      "holding pattern at arrival",
    ],
    REDUCED_ENGINE_TAXI_OUT: [
      "Last-minute runway change",
      "APU inoperative",
      "heavy on taxi out, and was uphill",
    ],
    REDUCED_ENGINE_TAXI_IN: [
      "There was not enough time to reti before reaching the gate",
      "Advised not to RETI for allocated parking stand",
      "APU inoperative",
      "Uphill taxi",
    ],
    OPTIMAL_DISCRETIONARY_FUEL_LOAD: [
      "Bad weather forecast at destination",
      "Taxiway closures",
      "Windshear expected towards destination alternative",
      "Last-minute runway changes",
      "Major tech issue led to long delay",
      "Fueller over fuelled the plane by 200kg",
    ],
    DELAYED_FLAPS_APPROACH: [
      "Last-minute runway change",
      "Training flight",
      "Bad visibility before approach",
      "visual approach was performed",
    ],
  };

  //Set all comments to the same date
  const eventOccurrenceMonth =
    params?.startDate != null
      ? params.startDate
      : moment.utc().startOf("month").valueOf();

  //Loop over all the Comment Texts above and turn them into comments
  let comments = [];
  Object.keys(commentTexts).forEach((behaviourKey) => {
    if (body?.behaviourNames?.length) {
      //Skip this behaviour if Behaviour Type filter is set
      if (!body.behaviourNames.includes(behaviourKey)) {
        return;
      }
    }
    const acronym = behaviourKey
      .split("_")
      .map((s) => s.charAt(0))
      .join("");
    commentTexts[behaviourKey].forEach((comment) => {
      comments.push({
        comment,
        eventOccurrenceMonth: eventOccurrenceMonth,
        behaviourAcronym: acronym,
        behaviourName: behaviourKey,
      });
    });
  });

  //Remove comments based on how many filters are set (removalFactor 3 -> array is divided by 3)
  let removalFactor = 1;
  if (body?.success === true) removalFactor += 5;
  if (body?.success === false) removalFactor += 1;
  if (body?.origin != null) removalFactor += 1;
  if (body?.destination != null) removalFactor += 1;
  if (removalFactor > 1) {
    comments.sort(() => Math.random() - 0.5);
    comments = comments.splice(0, Math.ceil(comments.length / removalFactor));
  }

  return {
    commentCount: comments.length,
    comments,
  };
};
